/**
 * Formulator types (epic PI-SPEC-SW-E282, contract formulator 1).
 *
 * Each string union is derived from an `as const` array so the API's Zod
 * schemas and the web pickers reuse the same list. Browser-safe: no runtime
 * dependencies.
 */
/** What the interview writes: a new or changed behaviour (`story`) or something broken (`bug`). */
export const FORMULATOR_KINDS = ["bug", "story"];
/** `create` writes a new item; `improve` overwrites the missing parts of an existing one. */
export const FORMULATOR_MODES = ["create", "improve"];
/**
 * Whose move it is: `claude` (the engine owes the next turn, for example the
 * opening turn of a session started elsewhere) or `person` (a question waits
 * for an answer, or the draft is complete).
 */
export const FORMULATOR_AWAITING = ["claude", "person"];
/** Lifecycle of an interview session (same values as the API's session store). */
export const FORMULATOR_SESSION_STATUSES = ["active", "submitting", "complete"];
/** Who wrote a transcript message. */
export const FORMULATOR_MESSAGE_ROLES = ["assistant", "user"];
/** How much of a product area the change touches (same values as grooming briefs). */
export const FORMULATOR_AREA_LEVELS = ["main", "small", "check"];
/** How a turn ended, as the `turn-finished` event reports it. */
export const FORMULATOR_TURN_OUTCOMES = ["asked", "complete", "failed"];
//# sourceMappingURL=types.js.map